import type { Job } from "../../lib/api";

/** Controller state takes precedence over the legacy status projection. */
export function currentBuildStatus(job: Job | null): Job["status"] | undefined {
  const execution = job?.execution;
  if (!execution) return job?.status;
  return execution.status === "running" ? "building" : execution.status;
}

export function elapsedLabel(start: number | undefined, now: number): string | null {
  if (!Number.isFinite(start) || !start || start > now) return null;
  const seconds = Math.floor((now - start) / 1000);
  return seconds < 60 ? `${seconds}s` : `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
}
